import { Injectable } from '@angular/core';
import { IIDolRiferimentiStore } from './iidOlRiferimenti.store';
import { IID_OL_RIFERIMENTI } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolRiferimentiQuery } from './iidOlRiferimenti.query';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { WsACKCallback, WsACKResponse } from '@common/api/ack';
import { RealtimeFeatureCommandPayloads } from '@common/api/realtime';
import { BuildingMetadata, IBuildingInfo } from '@common/interfaces/gisfo';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

const TOPIC = Topics.IID_OL_RIFERIMENTI;
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.RIFERIMENTI)
export class IIDolRiferimentiService extends CrudService<IID_OL_RIFERIMENTI, IIDolRiferimentiStore, IIDolRiferimentiQuery> {
  constructor(
    protected store: IIDolRiferimentiStore,
    public query: IIDolRiferimentiQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(
      TOPIC,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  refresh(id: string, callback?: WsACKCallback<IID_OL_RIFERIMENTI>) {
    this.featureCommandService.send<IID_OL_RIFERIMENTI>(
      {
        target: 'feature:signal',
        command: 'building:refresh',
        dto: { id },
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(TOPIC, 'refresh', { id }, response => this.completeLegacyCommand(response, callback)),
      callback,
    );
  }

  selectBuilding(payload: { id: string; building: IBuildingInfo | BuildingMetadata }, callback?: WsACKCallback<IID_OL_RIFERIMENTI>) {
    this.featureCommandService.send(
      {
        target: 'feature:signal',
        command: 'building:select',
        dto: payload,
        ...this.projectIdFromEntity(payload.id),
      },
      () => this.actionService.sendMessage(TOPIC, 'selectBuilding', { payload }, response => this.completeLegacyCommand(response, callback)),
      callback,
    );
  }

  updateUiCapacity(payload: RealtimeFeatureCommandPayloads['feature:signal']['building:updateUiCapacity'],
    callback: WsACKCallback<IID_OL_RIFERIMENTI>) {
    this.featureCommandService.send<IID_OL_RIFERIMENTI>(
      { target: 'feature:signal', command: 'building:updateUiCapacity', dto: payload, ...this.projectIdFromEntity(payload.id) },
      () => this.actionService.sendMessage(TOPIC, 'updateUiCapacity', payload, response => this.completeLegacyCommand(response, callback)),
      callback,
    );
  }

  private completeLegacyCommand(response: WsACKResponse<IID_OL_RIFERIMENTI>, callback?: WsACKCallback<IID_OL_RIFERIMENTI>) {
    if (response.status === 'success' && response.body) {
      const current = this.query.getEntity(response.body.id);
      if (!current || response.body.version >= current.version) {
        this.update(response.body, true);
      }
    }
    callback?.(response);
  }

  private projectIdFromEntity(id: string): { projectId?: string } {
    const projectId = this.query.getEntity(id)?.projectId;
    return projectId ? { projectId } : {};
  }

}
